module.exports = __webpack_public_path__ + "static/main-banner_photos-right_3x-f2a1c1883c4cd8320c8b4e58673b5f64_resized-5293830dcbd58f7edcce6ae0133fdf96.webp";